import React from "react";
import { Popover, Typography, Space, Tag, Button } from "antd";
import {
  MailOutlined,
  GlobalOutlined,
  FacebookOutlined,
  InstagramOutlined,
  TwitterOutlined,
  SendOutlined,
  EditOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom"; // ✅ Correct Link import
import { IBettingWebsiteContacts } from "../../../../types/BettingWebsite";

const { Text } = Typography;

type Props = {
  contacts: IBettingWebsiteContacts | null | undefined;
  page: number;
  pageSize: number;
  id: string;
};

const contactIcons: Partial<
  Record<keyof IBettingWebsiteContacts, React.ReactNode>
> = {
  Email: <MailOutlined />,
  Web: <GlobalOutlined />,
  Facebook: <FacebookOutlined />,
  Telegram: <SendOutlined />,
  Instagram: <InstagramOutlined />,
  X: <TwitterOutlined />,
};

const labelMap: Record<keyof IBettingWebsiteContacts, string> = {
  Email: "Email",
  Web: "Website",
  Facebook: "Facebook",
  Telegram: "Telegram",
  Instagram: "Instagram",
  X: "X (Twitter)",
};

export const ContactsPopover: React.FC<Props> = ({
  contacts,
  page,
  pageSize,
  id,
}) => {
  if (!contacts) {
    return <Tag>No Contacts</Tag>;
  }

  const content = (
    <div className="space-y-2 w-full">
      {Object.entries(contacts).map(([key, value]) => {
        const typedKey = key as keyof IBettingWebsiteContacts;
        if (!value) return null;
        const isLink = typedKey !== "Email";

        return (
          <div
            key={key}
            className="flex justify-between w-full items-center gap-3"
          >
            <Space>
              {contactIcons[typedKey]}
              <Text>{labelMap[typedKey]}</Text>
            </Space>

            {isLink ? (
              <a
                className="text-xs"
                href={value}
                target="_blank"
                rel="noopener noreferrer"
              >
                <Text copyable>{value}</Text>
              </a>
            ) : (
              <Text copyable>{value}</Text>
            )}
          </div>
        );
      })}
    </div>
  );

  return (
    <Popover
      title={
        <div className="flex flex-row w-full justify-between border-b pb-0.5">
          <span>Contacts</span>
          <Link
            to={`/betting-websites/edit-contacts/${id}?page=${
              page + 1
            }&pageSize=${pageSize}`}
          >
            <Button size="small" type="link" icon={<EditOutlined />} />
          </Link>
        </div>
      }
      content={content}
      trigger="hover"
      overlayStyle={{ width: 400 }}
      placement="right"
    >
      <Tag color="green" className="cursor-pointer">
        Show Contacts
      </Tag>
    </Popover>
  );
};
